import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import Dialog from '../../common/components/Dialog';
import ui from '../../common/services/ui';
import { fetchSubscriptionAcceptance } from './actions';

/**
 * What the parent was shown and accepted at checkout - the evidence for the subscription contract.
 */
class SubscriptionAcceptanceDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			acceptance: null
		};
	}

	componentDidUpdate(prevProps) {
		const { show, paymentId, fetchSubscriptionAcceptance } = this.props;
		if (show && !prevProps.show && !this.state.acceptance) {
			fetchSubscriptionAcceptance(paymentId, acceptance => this.setState({ acceptance }));
		}
	}

	renderBody() {
		const { t } = this.props;
		const { acceptance } = this.state;
		if (!acceptance) {
			return null;
		}

		const row = (label, value) => value ? <tr><th style={{ width: '30%' }}>{label}</th><td>{value}</td></tr> : null;
		return <div>
			<Table className='table-no-top-border'>
				<tfoot>
					{row(t('PaymentHistory_Acceptance_AcceptedAt'), ui.formatDateTime(acceptance.acceptedAt))}
					{row(t('PaymentHistory_Acceptance_IpAddress'), acceptance.ipAddress)}
					{row(t('PaymentHistory_Acceptance_UserAgent'), acceptance.userAgent)}
					{row(t('PaymentHistory_Acceptance_Language'), acceptance.cultureName)}
					{row(t('PaymentHistory_Acceptance_Note'), acceptance.note)}
					{row(t('PaymentHistory_Acceptance_Acknowledgement'), acceptance.acknowledgementText)}
				</tfoot>
			</Table>
			{/* stored exactly as the parent saw it */}
			<div dangerouslySetInnerHTML={{ __html: acceptance.keyInfoHtml }} />
			{acceptance.termsHtml && <div>
				<h4>{t('PaymentHistory_Acceptance_Terms')}</h4>
				<div dangerouslySetInnerHTML={{ __html: acceptance.termsHtml }} />
			</div>}
		</div>;
	}

	render() {
		const { show, onCancel, t } = this.props;
		const config = {
			header: t('PaymentHistory_Subscription_ViewAcceptance'),
			body: this.renderBody(),
			onHide: onCancel
		};
		return <Dialog config={config} show={show} t={t} bsSize='large' />;
	}
}

SubscriptionAcceptanceDialog.propTypes = {
	show: PropTypes.bool,
	paymentId: PropTypes.number.isRequired,
	onCancel: PropTypes.func.isRequired
};

export default connect(null, { fetchSubscriptionAcceptance })(withTranslation()(SubscriptionAcceptanceDialog));
